function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import PolygonIcon from 'svg/polygon.svg';
import ActivityIcon from 'svg/activity.svg';
import messages from '../messages';
import * as shapes from '../shapes';
import styles from './ActivityTooltip.pcss';
var _React_PureComponent;
class ActivityTooltip extends (_React_PureComponent = React.PureComponent) {
    renderTitle() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.activityTooltip__title,
            children: [
                /*#__PURE__*/ _jsx(ActivityIcon, {
                    className: styles.activityTooltip__titleIcon
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.activityTooltip__titleText,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.activity.label))
                })
            ]
        });
    }
    renderType() {
        const { activity } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.activityTooltip__detail,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.activityTooltip__detailType,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.activity.labels.type))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.activityTooltip__detailValue,
                    children: activity.name
                })
            ]
        });
    }
    renderTime() {
        const { activity } = this.props;
        const time = moment.unix(activity.timestamp).utc().format('LT');
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.activityTooltip__detail,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.activityTooltip__detailType,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.activity.labels.time))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.activityTooltip__detailValue,
                    children: time
                })
            ]
        });
    }
    renderDuration() {
        const { activity } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.activityTooltip__detail,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.activityTooltip__detailType,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.activity.labels.duration))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.activityTooltip__detailValue,
                    children: [
                        activity.duration,
                        " ",
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.activity.labels.timeUnit)),
                        "."
                    ]
                })
            ]
        });
    }
    renderDetails() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.activityTooltip__details,
            children: [
                this.renderType(),
                this.renderTime(),
                this.renderDuration()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.activityTooltip,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.activityTooltip__content,
                children: [
                    this.renderTitle(),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.activityTooltip__separator
                    }),
                    this.renderDetails(),
                    /*#__PURE__*/ _jsx(PolygonIcon, {
                        width: "17",
                        height: "12",
                        className: styles.activityTooltip__polygon
                    })
                ]
            })
        });
    }
}
_define_property(ActivityTooltip, "propTypes", {
    // Explicit props
    activity: shapes.activity.isRequired
});
export default withStyles(styles)(ActivityTooltip);
